import {Injectable} from '@angular/core';
import {HarbourDuesDeclaration, HarbourDuesDeclarationStatus} from "@portbase/bezoekschip-service-typescriptmodels";
import {AppContext} from "../../../app-context";
import {VisitContext} from "../../visit-context";

@Injectable({
  providedIn: 'root'
})
export class HarbourDuesPermissionService {
  isAvailable(): boolean {
    return this.hasArrived() && (AppContext.isAdmin() || VisitContext.isFinancialDeclarant() || AppContext.isHarbourDuesViewer());
  }

  hasArrived(): boolean {
    return VisitContext.savedVisit.visitDeclaration?.portVisit?.ataPort !== null
      && VisitContext.savedVisit.visitDeclaration?.portVisit?.ataPort !== undefined;
  }

  canEdit(declarationSelected?: HarbourDuesDeclaration): boolean {
    return declarationSelected !== undefined
        && this.isAvailable()
        && (VisitContext.isFinancialDeclarant() || AppContext.isHarbourDuesReviewer())
        && declarationSelected
        && ![HarbourDuesDeclarationStatus.DECLARED].includes(this.declarationStatus(declarationSelected));
  }

  canSaveUndeclaredDeclaration(declarationSelected: HarbourDuesDeclaration): boolean {
    return this.isAvailable()
      && !AppContext.isHarbourDuesReviewer()
      && declarationSelected
      && ![HarbourDuesDeclarationStatus.DECLARED, HarbourDuesDeclarationStatus.ACCEPTED, HarbourDuesDeclarationStatus.REJECTED]
        .includes(this.declarationStatus(declarationSelected));
  }

  declarationStatus(declarationSelected: HarbourDuesDeclaration) {
    return declarationSelected.status;
  }
}
